import {Video} from '@styled-icons/fluentui-system-regular/Video'
import {MusicNote1} from '@styled-icons/fluentui-system-regular/MusicNote1'
import {RecordVoiceOver} from '@styled-icons/material-outlined/RecordVoiceOver'
import {PersonVideo2} from '@styled-icons/bootstrap/PersonVideo2'

export const dancesListKeys = ['_id', 'nameEng', 'nameHeb', 'choreographers']

export const types = [
    'SPECIAL_NEEDS',
    'SEATING_AND_STANDING',
    'WOMEN_ONLY',
    'GOLDEN_AGE',
    'SALSA_AND_RUEDA',
    'BALLROOM_AND_LATIN',
    'CHILDREN',
    'INTERNATIONAL',
    'WORKSHOPS',
    'NOSTALGIA',
    'MARATHONS_AND_SPECIAL',
    'FESTIVALS_WEEKENDS_TRIPS',
    'WEEKLY',
]

export const shapes = [
    'CIRCLE',
    'COUPLES',
    'LINES',
    'SESSION',
    'IMITATION_FOR_CHILDREN',
    'WHEELCHAIRS',
    'CHILDREN_LINES',
    'TRIOS',
    'MEDLEY',
    'CHILDREN_COUPLES',
    'CHILDREN_CIRCLE',
    'PERFORMANCE',
    'DANCE_DELIGHT',
]

export const fileTypes = [
    'fv', // 'full video',
    'af', // 'full audio',
    'dv', // 'dance video',
    'tv', // 'teach video',
]

export const videoTypes = ['videoFull', 'videoTeach', 'videoDance']

export const videoIconMap = {
    videoFull: {Icon: Video, titleKey: 'dances.videoFull', size: 18},
    videoTeach: {
        Icon: RecordVoiceOver,
        titleKey: 'dances.videoTeach',
        size: 18,
    },
    videoDance: {Icon: PersonVideo2, titleKey: 'dances.videoDance', size: 17},
    audio: {Icon: MusicNote1, titleKey: 'dances.audio', size: 18},
}
